import { IGamePlayMessages } from '@GFTypes/GameStoreTypes';

export const GAME_PLAY_MESSAGES_DEFAULTS: IGamePlayMessages = {
    winning: '',
    information: '',
    showWinning: true,
    showInformation: true
};
